import { mapValues } from "lodash";
import { RevokePedestrianRightsModel } from "../../models/vehicle-assignments/RevokePedestrianRightsModel";
import { DeletePedestrianDelegeesModel } from "../../models/vehicle-assignments/DeletePedestrianDelegeesModel";
import { PedestrianRightsPagedData } from "../reducers/pedestrian-rights.reducer";
import { DelegatedPedestrianRight } from "../../models/delegations/DelegatedPedestrianRight";
import { InvitePedestrianRightRequestModel } from "../../models/InvitePedestrianRightRequestModel";
import { Statuses } from "../../components/DelegeeStatus/DelegeeStatus";
import { PedestrianProductModel } from "../../models/PedestrianProductModel";

export function reduceRevokePedestrianMyProducts(
    state: PedestrianRightsPagedData<DelegatedPedestrianRight>,
    revokeModel: RevokePedestrianRightsModel
): PedestrianRightsPagedData<DelegatedPedestrianRight> {
    const newPages = mapValues(state.pages, (page) => {
        return { ...page, data: page.data?.filter((item) => !revokeModel.entryRightIds.includes(item.id)) };
    });

    return {
        ...state,
        pages: newPages,
        totalRecords: state.totalRecords - revokeModel.entryRightIds.length,
    };
}

export function reduceDeletePedestrianMyProducts(
    state: PedestrianRightsPagedData<DelegatedPedestrianRight>,
    deleteModel: DeletePedestrianDelegeesModel
): PedestrianRightsPagedData<DelegatedPedestrianRight> {
    const newPages = mapValues(state.pages, (page) => {
        return { ...page, data: page.data?.filter((item) => !deleteModel.delegeeIds.includes(item.delegee.id)) };
    });

    return {
        ...state,
        pages: newPages,
        totalRecords: state.totalRecords - deleteModel.delegeeIds.length,
    };
}

export function reduceInvitePedestrianMyProducts(
  state: PedestrianRightsPagedData<DelegatedPedestrianRight>,
  pedestrianProducts: PedestrianProductModel[],
  inviteModel: InvitePedestrianRightRequestModel) :  
  PedestrianRightsPagedData<DelegatedPedestrianRight> {
    const fakeDelegees = inviteModel.pedestrianProducts.map(pedestrianProduct => {
      const product = pedestrianProducts.find(product => product.pmcId === pedestrianProduct.pmcId && product.seasonTicketReferenceId === pedestrianProduct.seasonTicketReferenceId);

      return <DelegatedPedestrianRight>{
        delegee: {
          email: inviteModel.email,
          name: inviteModel.name ?? "",
          id: inviteModel.email + pedestrianProduct.pmcId + pedestrianProduct.seasonTicketReferenceId
        },
        id: inviteModel.email + pedestrianProduct.pmcId + pedestrianProduct.seasonTicketReferenceId,
        invitationDate: new Date(),
        product: {
          pmcId: pedestrianProduct.pmcId,
          locationName: product?.locationName ?? "",
          pmcName: product?.pmcName ?? "",
        },
        status: Statuses.Pending
      }
    }
  );

    const newPages = mapValues(state.pages, (page) => {
      return {...page, data: fakeDelegees.concat(page.data!)}
    });

    return {
      ...state,
      pages: newPages,
      totalRecords: state.totalRecords + fakeDelegees.length,
    };
  }